export {
    getQueryKey,
    type ExtraMutationOptions,
    type ExtraQueryOptions,
    type FetchFn,
    type QueryError,
} from '../runtime/common';
export * from '../runtime/prisma-types';
